<template>
  <div class="articleAdmini">
    <div class="articleAdmini_top">
      <el-button type="success"
                 size="small"
                 @click="addArticle">添加文章 <div class="el-icon-plus"></div>
      </el-button>
    </div>
    <el-table :data="articleData"
              style="width: 100%"
              height="900px">
      <el-table-column label="封面图片"
                       width="130">
        <template slot-scope="scope">
          <el-image style="width: 100px; height: 100px"
                    :src="scope.row.thumb"
                    :preview-src-list="[scope.row.thumb]"
                    fit="fit"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="创建日期"
                       sortable
                       prop="createtime"
                       width="160">
        <template slot-scope="scope">
          {{common.formatDate(scope.row.createtime)}}
        </template>
      </el-table-column>
      <el-table-column prop="click"
                       sortable
                       label="阅读次数"
                       width="100">
      </el-table-column>
      <el-table-column prop="title"
                       label="文章标题"
                       show-overflow-tooltip
                       width="180">
      </el-table-column>
      <el-table-column prop="description"
                       show-overflow-tooltip
                       width="180"
                       label="文章描述">
      </el-table-column>
      <el-table-column label="标签">
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">
              <el-tag v-for="(item,index) in scope.row.tag"
                      size="mini"
                      style="margin-right:5px"
                      :key="index">{{item}}</el-tag>
            </div>
            <div class="showData">
              <el-tag v-for="(item,index) in scope.row.tag"
                      size="mini"
                      style="margin-right:5px"
                      :key="index">{{item}}</el-tag>
            </div>
          </el-tooltip>

        </template>
      </el-table-column>
      <el-table-column label="文章控制"
                       align="right"
                       width="250">
        <template slot-scope="scope">
          <el-button size='mini'
                     @click="skipEditArticle(scope.row.id)"
                     type="primary">编辑</el-button>
          <el-button size='mini'
                     @click="setArticleCommend(scope.row.id,scope.row.iscommend==1?0:1,scope.$index)"
                     :type="scope.row.iscommend==1?'danger':'success'">{{scope.row.iscommend==1?'关闭推荐':'开启推荐'}}</el-button>
          <el-button size='mini'
                     @click="removeArticle(scope.row.id)"
                     type="danger">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page.sync="page"
                   :page-sizes="[10,20,50,70,100, 200, 300, 400]"
                   :page-size="pagesize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="articleNum">
    </el-pagination>
  </div>
</template>

<script>
import { apiGetArticle, apiRemoveArticle, articleCommend } from '@/request/api'
import common from '@/assets/js/common'
export default {
  data () {

    return {
      // 当前页码
      page: 1,
      // 一页显示数量
      pagesize: 10,
      // 文章总数量
      articleNum: 0,
      // 公共方法
      common,
      // 营销网站数据
      mid: '',
      // 文章数据列表
      articleData: []
    }
  },
  methods: {
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.getArticle()
      // console.log(`当前页: ${val}`);
    },
    // 设置文章推荐
    async setArticleCommend (id, iscommend, index) {
      let res = await articleCommend({
        siteid: this.mid,
        id,
        iscommend
      })
      this.$message(res.message)
      this.$nextTick(() => {
        this.articleData[index].iscommend = iscommend
      })
    },
    // 添加文章
    addArticle () {
      this.$router.push({
        name: 'article',
        query: {
          callback: location.href,
          siteid: this.mid,
        }
      })
    },
    // 删除文章
    removeArticle (id) {
      this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await apiRemoveArticle({
          siteid: this.mid,
          id
        })
        this.$message(res.message)
        this.getArticle()

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 跳转编辑文章
    skipEditArticle (id) {
      this.$router.push({
        name: 'article',
        query: {
          callback: location.href,
          siteid: this.mid,
          id
        }
      })
    },
    // 获取文章
    async getArticle () {
      let res = await apiGetArticle({
        siteid: this.mid,
        page: this.page,
        pageSize: this.pagesize
      })
      if (res.errno != -1) {
        // for (let i = 0; i < res.article.length; i++) {
        //   if (res.article[i].content == 'showNull') {
        //     res.article.splice(i--, 1);
        //   }
        // }
      }
      this.articleNum = parseInt(res.totalNum)
      this.articleData = res.article
    }
  },
  created () {
    this.mid = this.$route.query.m_id
    this.getArticle()
  }
}
</script>

<style lang='scss'>
.articleAdmini {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .el-pagination {
    flex: 1;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    max-height: 50px;
    min-height: 50px;
  }
  .articleAdmini_top {
    max-height: 100px;
    min-height: 100px;
    flex: 1;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.showData {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>